// Module
var code = "<div class=\"text-center\" layout=\"column\" layout-padding> <h5>Please wait while we load and select all the items</h5> <md-progress-linear md-mode=\"determinate\" value=\"{{ dialog.progress }}\"></md-progress-linear> </div> ";
// Exports
module.exports = code;